module.exports = __webpack_public_path__ + "static/media/checkbox_white.72648139.svg";